function unflatten(array, parent = null, idKey = 'id', parentIdKey = 'parentId', tree = []) {
  const finalParent = parent || { [idKey]: undefined };
  let finalTree = tree;

  const children = array.filter(child => child[parentIdKey] === finalParent[idKey]);
  if (!children.length) {
    return tree;
  }

  if (finalParent[idKey] === undefined || finalParent[idKey] === 0 || finalParent[idKey] === null) {
    finalTree = children;
  } else {
    finalParent.items = children;
  }
  Object.keys(children).forEach(child => {
    unflatten(array, children[child], idKey, parentIdKey, finalTree);
  });

  return finalTree;
}

function flattenHierarchy(data, key = 'name', flattened = {}) {
  if (!Array.isArray(data)) return flattened;

  data.forEach(element => {
    const { [key]: flattenKey, items = [] } = element;
    if (!flattenKey) return;

    // eslint-disable-next-line no-param-reassign
    flattened[flattenKey] = element;
    flattenHierarchy(items, key, flattened);
  });
  return flattened;
}

module.exports = { unflatten, flattenHierarchy };
